import { useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import TruxFormField from 'src/components/inputs/trux-form-field';

type CreateTripDialogProps = {
  open: boolean;
  editing: boolean;
  creating: boolean;
  driverName: string;
  stopCount: number;
  plannedDepartAt: string | null;
  timezone: string;
  initialName: string;
  onClose: () => void;
  onConfirm: (name: string) => void;
};

export default function CreateTripDialog({
  open,
  editing,
  creating,
  driverName,
  stopCount,
  plannedDepartAt,
  timezone,
  initialName,
  onClose,
  onConfirm,
}: CreateTripDialogProps) {
  const [name, setName] = useState(initialName);

  const departsText = plannedDepartAt
    ? DateTime.fromISO(plannedDepartAt).setZone(timezone).toFormat('LLL d, h:mm a')
    : '—';

  return (
    <Dialog open={open} onClose={creating ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{editing ? 'Save Trip Changes' : 'Create Trip'}</DialogTitle>
      <DialogContent>
        <Stack direction="column" gap={2} sx={{ pt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {driverName} · {stopCount} {stopCount === 1 ? 'stop' : 'stops'} · departs {departsText}
          </Typography>
          <TruxFormField label="Trip name">
            <TextField
              size="small"
              autoComplete="off"
              sx={{ display: 'flex' }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Optional, e.g. the load number"
            />
          </TruxFormField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={creating}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onConfirm(name)} disabled={creating}>
          {creating ? <CircularProgress size={22} sx={{ color: 'white' }} /> : (
            <>{editing ? 'Save Changes' : 'Create Trip'}</>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
